export const OPEN_ATTACHMENT = "OPEN_ATTACHMENT";
export const CLOSE_ATTACHMENT = "CLOSE_ATTACHMENT";
export const SET_CURRENT_ATTACHMENT_INDEX = "SET_CURRENT_ATTACHMENT_INDEX";
export const UPDATE_ATTACHMENT_NUM_PAGES = "UPDATE_ATTACHMENT_NUM_PAGES";
export const CLOSE_ALL_ATTACHMENTS = "CLOSE_ALL_ATTACHMENTS";
export const SET_ALL_DOCUMENTS_SAVED = "SET_ALL_DOCUMENTS_SAVED";
export const SET_ACTIVE_HIGHLIGHT = "SET_ACTIVE_HIGHLIGHT";

export interface OpenAttachmentAction {
  type: typeof OPEN_ATTACHMENT;
  payload: any;
}

export interface CloseAttachmentAction {
  type: typeof CLOSE_ATTACHMENT;
  payload: string;
}

export interface SetCurrentAttachmentIndexAction {
  type: typeof SET_CURRENT_ATTACHMENT_INDEX;
  payload: number;
}

export interface UpdateAttachmentNumPagesAction {
  type: typeof UPDATE_ATTACHMENT_NUM_PAGES;
  payload: {
    attachmentId: string;
    numPages: number;
  };
}

export interface CloseAllAttachmentsAction {
  type: typeof CLOSE_ALL_ATTACHMENTS;
}

export interface SetAllDocumentsSavedAction {
  type: typeof SET_ALL_DOCUMENTS_SAVED;
  payload: boolean;
}

export interface SetActiveHighlightAction {
  type: typeof SET_ACTIVE_HIGHLIGHT;
  payload: string | null;
}

export type AttachmentActionTypes =
  | OpenAttachmentAction
  | CloseAttachmentAction
  | SetCurrentAttachmentIndexAction
  | UpdateAttachmentNumPagesAction
  | CloseAllAttachmentsAction
  | SetAllDocumentsSavedAction
  | SetActiveHighlightAction;
